/**
 * INFINITY LIFE 2.0 — High-Converting Sales Landing Page
 * Apresentação irresistível com copy profissional, demonstração dos recursos e checkout Asaas
 */

import { store } from '../state.js';
import { openCheckoutModal } from './CheckoutModal.js';

export function renderLandingPage() {
  const { user } = store.get();
  const isLogged = !!user;

  return `
    <div class="landing-page">
      <!-- Glow Decorativo Superior -->
      <div class="landing-glow-top"></div>

      <!-- Barra de Navegação Superior da Landing -->
      <header class="landing-nav">
        <div class="landing-container landing-nav-inner">
          <div class="landing-brand" id="brand-logo-click">
            <img src="/icons/icon-192.svg" alt="Infinity Life" style="width: 38px; height: 38px; filter: drop-shadow(0 0 10px var(--primary-glow));" />
            <div style="display: flex; flex-direction: column;">
              <span style="font-weight: 800; font-size: 1.25rem; letter-spacing: -0.02em; background: var(--grad-primary); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">INFINITY</span>
              <span style="font-size: 0.65rem; font-weight: 700; color: var(--text-muted); letter-spacing: 0.15em;">LIFE OS 2.0</span>
            </div>
          </div>

          <nav class="landing-nav-menu" style="display: none; @media(min-width: 800px){ display: flex; }">
            <a href="#solucao" class="landing-nav-item">A Solução</a>
            <a href="#recursos" class="landing-nav-item">Recursos</a>
            <a href="#negocio" class="landing-nav-item">Home Office & Negócio</a>
            <a href="#planos" class="landing-nav-item">Planos & Acesso</a>
            <a href="#faq" class="landing-nav-item">Dúvidas Frequentes</a>
          </nav>

          <div class="landing-nav-actions">
            ${isLogged ? `
              <button class="btn-primary" id="btn-enter-platform" style="padding: 10px 20px; font-weight: 700; box-shadow: 0 0 20px var(--primary-glow);">
                <span>⚡ Meu Painel (Liberado) →</span>
              </button>
            ` : `
              <button class="btn-secondary" id="btn-landing-login" style="padding: 9px 18px; font-weight: 600;">
                <span>🔑 Já Sou Membro / Entrar</span>
              </button>
              <a href="#planos" class="btn-primary" style="padding: 9px 18px; font-weight: 700;">
                <span>Garantir Acesso</span>
              </a>
            `}
          </div>
        </div>
      </header>

      ${isLogged ? `
        <!-- Banner de Usuário Logado -->
        <div style="background: rgba(99, 102, 241, 0.15); border-bottom: 1px solid rgba(99, 102, 241, 0.3); padding: 10px 20px; text-align: center; font-size: 0.88rem; color: #c7d2fe;">
          <span>👑 Você está autenticado como <strong>${user.name || 'Proprietário'}</strong> com <strong>acesso total liberado</strong>.</span>
          <button id="btn-banner-go-app" style="color: #ffffff; text-decoration: underline; font-weight: 700; margin-left: 8px;">
            Ir direto para a Central de Comando →
          </button>
        </div>
      ` : ''}

      <!-- HERO SECTION -->
      <section class="landing-hero">
        <div class="landing-container">
          <div class="hero-pill">
            <span>✨ O Primeiro Sistema Operacional da Vida Real • PWA Offline-First</span>
          </div>

          <h1 class="hero-headline">
            Chega de se perder entre 10 aplicativos diferentes.<br />
            <span class="gradient-text">Conquiste Clareza Absoluta, Foco Diário e Controle Total.</span>
          </h1>

          <p class="hero-subheadline">
            O <strong>Infinity Life 2.0</strong> une o Dashboard <em>"Meu Dia"</em>, rotina comercial de trabalho autônomo,
            planejamento financeiro rigoroso, hábitos, lembretes reais e inteligência artificial Google Gemini
            em uma única plataforma ultrarrápida, instalável no celular e <strong>100% funcional sem internet</strong>.
          </p>

          <div class="hero-cta-group">
            <a href="#planos" class="btn-cta-large" id="btn-hero-enroll">
              <span>🚀 Desbloquear Meu Acesso Agora</span>
              <span>→</span>
            </a>

            <button class="btn-cta-outline" id="btn-hero-test-access">
              <span>⚡ ${isLogged ? 'Abrir Minha Central' : 'Área de Membros (Entrar)'}</span>
            </button>
          </div>

          <div class="hero-proof-list">
            <div class="hero-proof-item"><span>✓</span> <span>100% Funcional Offline</span></div>
            <div class="hero-proof-item"><span>✓</span> <span>PWA Instalável no iOS, Android & PC</span></div>
            <div class="hero-proof-item"><span>✓</span> <span>Sem Mensalidades Obrigatórias</span></div>
            <div class="hero-proof-item"><span>✓</span> <span>Pagamento Seguro Asaas (PIX & Cartão)</span></div>
          </div>

          <!-- MOCKUP VISUAL INTERATIVO -->
          <div class="mockup-wrapper">
            <div class="mockup-inner" style="padding: 24px; text-align: left;">
              <!-- Mini Header Simulado -->
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; border-bottom: 1px solid var(--border-subtle); padding-bottom: 14px;">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <span style="font-size: 1.4rem;">☀️</span>
                  <div>
                    <div style="font-weight: 800; font-size: 1.1rem; color: var(--text-primary);">Meu Dia — Central de Produtividade</div>
                    <div style="font-size: 0.75rem; color: var(--text-muted);">Visualização do Dashboard Integrado</div>
                  </div>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span class="status-pill online"><span class="dot"></span> Online & PWA Sincronizado</span>
                </div>
              </div>

              <!-- Metrics Showcase -->
              <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 14px; margin-bottom: 20px;">
                <div style="background: var(--bg-tertiary); padding: 14px; border-radius: var(--radius-md); border: 1px solid var(--border-subtle);">
                  <div style="font-size: 0.75rem; color: var(--text-muted); font-weight: 700;">Progresso de Hoje</div>
                  <div style="font-size: 1.5rem; font-weight: 800; color: var(--emerald-accent); margin: 4px 0;">75% Concluído</div>
                  <div class="progress-bar-bg" style="height: 6px;"><div class="progress-bar-fill" style="width: 75%;"></div></div>
                </div>

                <div style="background: var(--bg-tertiary); padding: 14px; border-radius: var(--radius-md); border: 1px solid var(--border-subtle);">
                  <div style="font-size: 0.75rem; color: var(--text-muted); font-weight: 700;">Capacidade de Trabalho</div>
                  <div style="font-size: 1.5rem; font-weight: 800; color: var(--cyan-accent); margin: 4px 0;">3h 15m Livres</div>
                  <div style="font-size: 0.72rem; color: var(--text-secondary);">Sem risco de sobrecarga mental</div>
                </div>

                <div style="background: var(--bg-tertiary); padding: 14px; border-radius: var(--radius-md); border: 1px solid var(--border-subtle);">
                  <div style="font-size: 0.75rem; color: var(--text-muted); font-weight: 700;">Rotina Comercial</div>
                  <div style="font-size: 1.5rem; font-weight: 800; color: var(--primary); margin: 4px 0;">3 Propostas Ativas</div>
                  <div style="font-size: 0.72rem; color: var(--text-secondary);">Expediente sob controle</div>
                </div>
              </div>

              <!-- Interactive Demo Item -->
              <div style="background: rgba(99, 102, 241, 0.08); border: 1px dashed var(--primary); border-radius: var(--radius-md); padding: 14px; display: flex; align-items: center; justify-content: space-between;">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <span style="font-size: 1.2rem;">⚡</span>
                  <div>
                    <div style="font-weight: 700; font-size: 0.92rem; color: var(--text-primary);">Próxima entrega: Apresentação para Cliente VIP</div>
                    <div style="font-size: 0.75rem; color: var(--text-muted);">Horário: 15:30 • Contexto: Computador • Prioridade Alta</div>
                  </div>
                </div>
                <button class="btn-primary" id="btn-mockup-try" style="padding: 6px 14px; font-size: 0.8rem;">
                  Experimentar Sistema →
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- O PROBLEMA VS A SOLUÇÃO -->
      <section class="landing-section" id="solucao" style="background: var(--bg-secondary);">
        <div class="landing-container">
          <div class="section-tag">O Fim da Dispersão</div>
          <h2 class="section-heading">Por que o método tradicional falha todos os dias?</h2>
          <p class="section-desc">
            Você tenta organizar a vida usando ferramentas separadas. O resultado é cansaço extremo e pouca realização.
          </p>

          <div class="comparison-grid">
            <!-- Card Problema -->
            <div class="comp-card problem">
              <div class="comp-title">
                <span style="color: var(--rose-accent);">✕</span>
                <span>O Caos de Múltiplos Apps</span>
              </div>
              <ul class="comp-list">
                <li><span>•</span> <span><strong>Sobrecarga mental:</strong> você abre o Notion para notas, Trello para tarefas, app do banco para finanças e WhatsApp para clientes.</span></li>
                <li><span>•</span> <span><strong>Falta de limite diário:</strong> você anota 30 coisas para fazer e dorme com a culpa de ter realizado apenas 3.</span></li>
                <li><span>•</span> <span><strong>Home Office sem fim:</strong> você não sabe a hora de parar e continua respondendo clientes na hora do jantar.</span></li>
                <li><span>•</span> <span><strong>Dependência de internet:</strong> sem sinal 4G, seu app trava ou você não tem acesso às anotações vitais.</span></li>
              </ul>
            </div>

            <!-- Card Solução -->
            <div class="comp-card solution">
              <div class="comp-title">
                <span style="color: var(--emerald-accent);">✓</span>
                <span>A Clareza do Infinity Life 2.0</span>
              </div>
              <ul class="comp-list">
                <li><span>•</span> <span><strong>Central Única de Comando:</strong> sua vida pessoal, trabalho e dinheiro conectados num único fluxo inteligente.</span></li>
                <li><span>•</span> <span><strong>Cálculo Realista de Horas:</strong> o sistema avisa se você tentar planejar mais de 8 horas de trabalho num dia.</span></li>
                <li><span>•</span> <span><strong>Checklist de Desconexão:</strong> rotina guiada de início e encerramento do expediente para você descansar com tranquilidade.</span></li>
                <li><span>•</span> <span><strong>PWA Offline-First:</strong> tudo funciona no avião, metrô ou sítio, sincronizando sozinho quando você voltar online.</span></li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <!-- OS RECURSOS ESSENCIAIS -->
      <section class="landing-section" id="recursos">
        <div class="landing-container">
          <div class="section-tag">Engenharia de Alta Performance</div>
          <h2 class="section-heading">Tudo o que você precisa para dominar sua rotina</h2>
          <p class="section-desc">
            Cada recurso foi desenhado para eliminar atrito e devolver a sua energia produtiva.
          </p>

          <div class="features-grid">
            <!-- 1. Meu Dia -->
            <div class="feature-box">
              <div class="feature-icon-wrap">☀️</div>
              <h3 class="feature-title">Dashboard "Meu Dia"</h3>
              <p class="feature-text">
                Saudação contextual, data formatada, barra de progresso em tempo real e a barra de <strong>Captura Rápida (⚡)</strong>: digite em 1 segundo e continue focado.
              </p>
            </div>

            <!-- 2. Trabalho Autônomo -->
            <div class="feature-box" id="negocio">
              <div class="feature-icon-wrap">💼</div>
              <h3 class="feature-title">Central do Meu Negócio</h3>
              <p class="feature-text">
                Gestão autônoma com checklist de início e fim de expediente, separação total entre trabalho e pessoal, pipeline de clientes e tarefas prioritárias de faturamento.
              </p>
            </div>

            <!-- 3. Agenda & Tarefas -->
            <div class="feature-box">
              <div class="feature-icon-wrap">📅</div>
              <h3 class="feature-title">Agenda Contextual</h3>
              <p class="feature-text">
                Filtre por onde você está: computador, celular, rua, cliente ou casa. Controle prioridades (Urgente 🔥, Alta ⚡, Média 🔹, Baixa 🌱) com prazos claros.
              </p>
            </div>

            <!-- 4. PWA Offline -->
            <div class="feature-box">
              <div class="feature-icon-wrap">📲</div>
              <h3 class="feature-title">Instalável & Offline Real</h3>
              <p class="feature-text">
                Tecnologia PWA instalável no iPhone e Android sem passar pela App Store. Funciona 100% offline com persistência em IndexedDB e sincronização automática.
              </p>
            </div>

            <!-- 5. Notificações Reais -->
            <div class="feature-box">
              <div class="feature-icon-wrap">🔔</div>
              <h3 class="feature-title">Notificações e Avisos Sonoros</h3>
              <p class="feature-text">
                Central de notificações com Web Push, avisos de prazos, lembretes de hidratação e postura, e avisos sonoros que não deixam você esquecer nada.
              </p>
            </div>

            <!-- 6. Inteligência Artificial Gemini -->
            <div class="feature-box">
              <div class="feature-icon-wrap">🤖</div>
              <h3 class="feature-title">Infinity AI (Google Gemini)</h3>
              <p class="feature-text">
                Assistente inteligente configurável diretamente pelo administrador com sua própria chave Gemini, sem custos extras de assinaturas de terceiros.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- PLANOS E PAGAMENTO (ASAAS INTEGRATION) -->
      <section class="landing-section" id="planos" style="background: var(--bg-secondary);">
        <div class="landing-container">
          <div class="section-tag">Acesso Imediato</div>
          <h2 class="section-heading">Escolha seu plano e comece hoje mesmo</h2>
          <p class="section-desc">
            Pagamento 100% seguro processado via <strong>Asaas</strong> com liberação imediata via PIX ou Cartão de Crédito.
          </p>

          <div class="pricing-grid">
            <!-- PLANO 1: MENSAL -->
            <div class="pricing-card">
              <div class="pricing-plan-name">Plano Mensal Pro</div>
              <div class="pricing-plan-desc">Ideal para quem quer flexibilidade e pagamento mês a mês.</div>

              <div class="pricing-price-wrap">
                <span class="price-currency">R$</span>
                <span class="price-value">29</span>
                <span class="price-period">,90 / mês</span>
              </div>

              <ul class="pricing-features-list">
                <li><span>✓</span> <span>Acesso a todos os módulos do sistema</span></li>
                <li><span>✓</span> <span>Dashboard "Meu Dia" & Captura Rápida</span></li>
                <li><span>✓</span> <span>Central de Trabalho Autônomo & Clientes</span></li>
                <li><span>✓</span> <span>PWA Instalável no celular e PC</span></li>
                <li><span>✓</span> <span>Funcionamento 100% Offline</span></li>
                <li><span>✓</span> <span>Sincronização em nuvem segura</span></li>
              </ul>

              <button class="btn-secondary btn-plan-select" data-plan="monthly" style="width: 100%; justify-content: center; padding: 14px; font-weight: 700;">
                Garantir Plano Mensal
              </button>
            </div>

            <!-- PLANO 2: ANUAL VIP (DESTAQUE) -->
            <div class="pricing-card featured">
              <div class="pricing-badge">Mais Escolhido • Economize 45%</div>
              <div class="pricing-plan-name">Acesso Anual VIP</div>
              <div class="pricing-plan-desc">Acesso completo durante 1 ano inteiro por menos de 70 centavos por dia.</div>

              <div class="pricing-price-wrap">
                <div style="font-size: 0.85rem; color: var(--text-muted); text-decoration: line-through;">De R$ 358,80 por apenas:</div>
                <span class="price-currency">R$</span>
                <span class="price-value">197</span>
                <span class="price-period">,00 / ano</span>
                <div style="font-size: 0.8rem; color: var(--emerald-accent); font-weight: 700; margin-top: 4px;">ou 12x de R$ 19,70 no cartão</div>
              </div>

              <ul class="pricing-features-list">
                <li><span>✓</span> <span><strong>Tudo do Plano Mensal incluído</strong></span></li>
                <li><span>✓</span> <span>1 Ano inteiro de atualizações contínuas</span></li>
                <li><span>✓</span> <span>Copiloto de IA Gemini desbloqueado</span></li>
                <li><span>✓</span> <span>Economia de R$ 161,80 no ano</span></li>
                <li><span>✓</span> <span>Suporte prioritário via WhatsApp</span></li>
                <li><span>✓</span> <span>Garantia incondicional de 7 dias</span></li>
              </ul>

              <button class="btn-primary btn-plan-select" data-plan="annual" style="width: 100%; justify-content: center; padding: 16px; font-weight: 800; font-size: 1.05rem;">
                🚀 Quero o Acesso Anual VIP
              </button>
            </div>

            <!-- PLANO 3: VITALÍCIO FOUNDER -->
            <div class="pricing-card">
              <div class="pricing-plan-name">Acesso Vitalício Founder</div>
              <div class="pricing-plan-desc">Pague uma única vez e tenha a plataforma para sempre, sem mensalidades.</div>

              <div class="pricing-price-wrap">
                <span class="price-currency">R$</span>
                <span class="price-value">297</span>
                <span class="price-period">,00 pagamento único</span>
                <div style="font-size: 0.8rem; color: var(--amber-accent); font-weight: 700; margin-top: 4px;">Acesso permanente sem cobranças futuras</div>
              </div>

              <ul class="pricing-features-list">
                <li><span>✓</span> <span><strong>Acesso vitalício definitivo</strong></span></li>
                <li><span>✓</span> <span>Zero mensalidades ou anuidades</span></li>
                <li><span>✓</span> <span>Todas as futuras versões da linha 2.x</span></li>
                <li><span>✓</span> <span>Módulo de IA Gemini ilimitado</span></li>
                <li><span>✓</span> <span>Backup local e exportação total de dados</span></li>
                <li><span>✓</span> <span>Selo de Membro Fundador</span></li>
              </ul>

              <button class="btn-secondary btn-plan-select" data-plan="lifetime" style="width: 100%; justify-content: center; padding: 14px; font-weight: 700;">
                Garantir Licença Vitalícia
              </button>
            </div>
          </div>

          <div style="text-align: center; margin-top: 40px; font-size: 0.9rem; color: var(--text-muted); display: flex; align-items: center; justify-content: center; gap: 8px;">
            <span>🛡️</span>
            <span>Garantia de 7 dias: se não transformar sua rotina, devolvemos 100% do valor pago.</span>
          </div>
        </div>
      </section>

      <!-- FAQ SECTION -->
      <section class="landing-section" id="faq">
        <div class="landing-container">
          <div class="section-tag">Tire Suas Dúvidas</div>
          <h2 class="section-heading">Perguntas Frequentes</h2>

          <div class="faq-list">
            <div class="faq-item">
              <div class="faq-question">
                <span>Preciso baixar o app pela Apple Store ou Google Play?</span>
                <span class="faq-icon">＋</span>
              </div>
              <div class="faq-answer">
                Não! O Infinity Life utiliza tecnologia PWA moderna. Você instala com 1 clique diretamente pelo navegador Safari ou Chrome, sem ocupar a memória pesada do celular e sem depender de lojas de aplicativos.
              </div>
            </div>

            <div class="faq-item">
              <div class="faq-question">
                <span>O sistema realmente funciona sem internet?</span>
                <span class="faq-icon">＋</span>
              </div>
              <div class="faq-answer">
                Sim! Suas tarefas, anotações e rotinas são salvas localmente no banco IndexedDB do seu aparelho. Você pode criar ou marcar tarefas no modo avião, e elas serão sincronizadas automaticamente com o servidor assim que você reconectar.
              </div>
            </div>

            <div class="faq-item">
              <div class="faq-question">
                <span>Como funciona o pagamento via Asaas?</span>
                <span class="faq-icon">＋</span>
              </div>
              <div class="faq-answer">
                O pagamento é processado diretamente pelo gateway seguro do Asaas, com suporte a PIX com liberação imediata e Cartão de Crédito. Assim que confirmado, seu e-mail cadastrado terá acesso liberado.
              </div>
            </div>

            <div class="faq-item">
              <div class="faq-question">
                <span>Como recebo meu acesso após a confirmação do pagamento?</span>
                <span class="faq-icon">＋</span>
              </div>
              <div class="faq-answer">
                Assim que a transação for confirmada pelo Asaas (liberação imediata no PIX ou no Cartão), você poderá entrar diretamente com sua conta e usar a plataforma no navegador ou instalá-la como aplicativo (PWA) no seu celular e computador.
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- BANNER FINAL CTA -->
      <section class="landing-container">
        <div class="final-cta-card">
          <h2 style="font-size: 2.2rem; font-weight: 800; margin-bottom: 14px;">
            Pronto para transformar sua rotina pessoal e profissional?
          </h2>
          <p style="font-size: 1.05rem; color: var(--text-secondary); max-width: 680px; margin: 0 auto 30px auto; line-height: 1.6;">
            Não deixe mais suas metas e finanças se perderem no caos diário. Desbloqueie o Infinity Life 2.0 e tenha clareza todos os dias.
          </p>
          <a href="#planos" class="btn-cta-large" style="margin: 0 auto;">
            <span>🚀 Quero Minha Central de Comando Agora</span>
          </a>
        </div>
      </section>

      <!-- FOOTER -->
      <footer class="landing-footer">
        <div class="landing-container">
          <div style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-bottom: 12px;">
            <img src="/icons/icon-192.svg" alt="Infinity Life" style="width: 24px; height: 24px;" />
            <span style="font-weight: 700; color: var(--text-primary);">Infinity Life 2.0</span>
          </div>
          <p style="margin-bottom: 16px;">Sua central completa de vida pessoal, finanças e trabalho autônomo. Desenvolvido para alta performance.</p>
          <div style="display: flex; justify-content: center; gap: 20px; font-size: 0.8rem;">
            <a href="#solucao" style="color: var(--text-muted);">A Solução</a>
            <a href="#recursos" style="color: var(--text-muted);">Recursos</a>
            <a href="#planos" style="color: var(--text-muted);">Planos</a>
            <button id="btn-footer-member-login" style="color: var(--text-muted); cursor: pointer; text-decoration: underline;">
              Área do Membro
            </button>
          </div>
          <div style="margin-top: 20px; font-size: 0.75rem; color: rgba(255,255,255,0.3);">
            © ${new Date().getFullYear()} Infinity Life. Todos os direitos reservados.
          </div>
        </div>
      </footer>

      <!-- Botão Flutuante de Suporte WhatsApp -->
      <a href="https://wa.me/?text=Ol%C3%A1!%20Tenho%20d%C3%BAvidas%20sobre%20os%20planos%20do%20Infinity%20Life%202.0" 
         target="_blank" rel="noopener noreferrer" class="whatsapp-float-btn" title="Falar com o Suporte via WhatsApp">
        <span>💬</span>
        <span>Suporte WhatsApp</span>
      </a>
    </div>
  `;
}


export function attachLandingPageEvents(container) {
  // Brand logo click
  const logo = container.querySelector('#brand-logo-click');
  if (logo) {
    logo.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // Go to Platform buttons (when logged in)
  const enterBtn = container.querySelector('#btn-enter-platform');
  const bannerGoBtn = container.querySelector('#btn-banner-go-app');
  const openApp = () => store.setView('my-day');

  if (enterBtn) enterBtn.addEventListener('click', openApp);
  if (bannerGoBtn) bannerGoBtn.addEventListener('click', openApp);

  // Login buttons
  const loginBtn = container.querySelector('#btn-landing-login');
  const heroTestBtn = container.querySelector('#btn-hero-test-access');
  const footerMemberBtn = container.querySelector('#btn-footer-member-login');
  const mockupTryBtn = container.querySelector('#btn-mockup-try');

  const openAuth = () => {
    const { user } = store.get();
    if (user) {
      store.setView('my-day');
    } else {
      store.toggleModal('auth', true);
    }
  };

  if (loginBtn) loginBtn.addEventListener('click', openAuth);
  if (heroTestBtn) heroTestBtn.addEventListener('click', openAuth);
  if (footerMemberBtn) footerMemberBtn.addEventListener('click', openAuth);
  if (mockupTryBtn) mockupTryBtn.addEventListener('click', openAuth);

  // Plan select buttons -> Opens Checkout Modal
  container.querySelectorAll('.btn-plan-select').forEach((btn) => {
    btn.addEventListener('click', () => {
      const planType = btn.dataset.plan;
      let planData = {
        id: 'annual',
        name: 'Acesso Anual VIP (Mais Popular)',
        price: 'R$ 197,00',
        period: '/ano (ou 12x de R$ 19,70)',
      };

      if (planType === 'monthly') {
        planData = {
          id: 'monthly',
          name: 'Plano Mensal Pro',
          price: 'R$ 29,90',
          period: '/mês',
        };
      } else if (planType === 'lifetime') {
        planData = {
          id: 'lifetime',
          name: 'Acesso Vitalício Founder',
          price: 'R$ 297,00',
          period: 'pagamento único vitalício',
        };
      }

      openCheckoutModal(planData);
    });
  });

  // FAQ Accordion toggles
  container.querySelectorAll('.faq-item').forEach((item) => {
    const q = item.querySelector('.faq-question');
    if (q) {
      q.addEventListener('click', () => {
        item.classList.toggle('open');
      });
    }
  });
}
